import { styled } from '@mui/system';
import { Box, Card, Badge } from '@mui/material';

export const Container = styled('div')`
  min-height: 100vh;
`;

export const SecondRowContainer = styled(Box)({
  maxWidth: '80vw',
  margin: '0 auto',
  '@media (max-width: 900px)': {
    maxWidth: '100%',
  },
});

export const StyledCard = styled(Card)(({ theme }) => ({
  position: 'relative',
  transition: 'transform 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: theme.shadows[4],
  },
}));

export const StatusBadge = styled(Box)(() => ({
  position: 'absolute',
  top: 12,
  right: 12,
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  padding: '4px 8px',
  borderRadius: '16px',
  backgroundColor: 'rgba(46, 125, 50, 0.9)',
  color: 'white',
  fontSize: '0.75rem',
  zIndex: 1,
}));

export const PendingBookingsBadge = styled(Badge)(({ theme }) => ({
  position: 'absolute',
  bottom: 12,
  right: 12,
  '& .MuiBadge-badge': {
    backgroundColor: theme.palette.error.main,
    color: 'white',
    fontSize: '0.85rem',
    padding: '0 6px',
    minWidth: '22px',
    height: '22px',
    borderRadius: '11px',
  },
}));

export const ImageContainer = styled(Box)({
  position: 'relative',
  paddingTop: '56.25%', // 16:9 aspect ratio
  borderRadius: '10px 10px 0 0',
  overflow: 'hidden',
});